'use client';
import { makeStyles, mergeClasses } from '@griffel/react';
import { getBarLabelStyle, getTooltipStyle } from '../../utilities/index';
export const verticalstackedbarchartClassNames = {
    opacityChangeOnHover: 'fui-vsbc__opacityChangeOnHover',
    tooltip: 'fui-vsbc__tooltip',
    barLabel: 'fui-vsbc__barLabel',
    root: '',
    xAxis: '',
    yAxis: '',
    legendContainer: '',
    hover: '',
    descriptionMessage: '',
    axisTitle: '',
    chartTitle: '',
    shapeStyles: '',
    chartWrapper: '',
    svgTooltip: '',
    chart: '',
    axisAnnotation: '',
    plotContainer: '',
    annotationLayer: ''
};
const useStyles = makeStyles({
    opacityChangeOnHover: {
        cursor: 'default'
    },
    tooltip: getTooltipStyle(),
    barLabel: getBarLabelStyle()
});
export const useVerticalStackedBarChartStyles = (props)=>{
    const baseStyles = useStyles();
    return {
        opacityChangeOnHover: mergeClasses(verticalstackedbarchartClassNames.opacityChangeOnHover, baseStyles.opacityChangeOnHover, props.href ? 'pointer' : 'default'),
        tooltip: mergeClasses(verticalstackedbarchartClassNames.tooltip, baseStyles.tooltip),
        barLabel: mergeClasses(verticalstackedbarchartClassNames.barLabel, baseStyles.barLabel)
    };
};
